import { render, staticRenderFns } from "./faqlist.vue?vue&type=template&id=7142f0d2&scoped=true&"
import script from "./faqlist.vue?vue&type=script&lang=js&"
export * from "./faqlist.vue?vue&type=script&lang=js&"
import style0 from "./faqlist.vue?vue&type=style&index=0&id=7142f0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142f0d2",
  null
  
)

export default component.exports